import React from 'react';
import Brands from '../components/brands';

const BrandPage = () => {
	return (
		<Brands />
	)
}

export default BrandPage;


// WEBPACK FOOTER //
// ./src/containers/brand-page.js